import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BdState } from '@bindoc-projects/geographic-domain-lib';
import { BdMapsStateSelectMultipleHandler } from '../../multiple-select-handler';
import {
  BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT,
  BdMapsStateSelectOptions,
} from '../../select-options';
import { BdMapsStateAbstractSelectList } from '../abstract-select-list';
import { Checkbox, CheckboxChangeEvent } from 'primeng/checkbox';
import { BdDataTestDirective } from '@bindoc-projects/util-lib/ui';

@Component({
  selector: 'bd-maps-state-select-list-multiple',
  template: `
    <div>
      <div class="flex flex-wrap">
        @for (
          stateOption of selectionHandler.statesOptions;
          track stateOption
        ) {
          <div class="basis-full md:basis-1/2 lg:basis-1/6">
            <div class="flex flex-row items-center gap-2">
              <p-checkbox
                [data-test]="'maps-state-' + stateOption.id + '-checkbox'"
                [inputId]="'maps-state-select-multiple-' + stateOption.id"
                [binary]="true"
                [ngModel]="isChecked(stateOption)"
                (onChange)="onCheckboxChange($event, stateOption)"
              />
              <label [for]="'maps-state-select-multiple-' + stateOption.id">{{
                stateOption?.name
              }}</label>
            </div>
          </div>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Checkbox, FormsModule, BdDataTestDirective],
})
export class BdMapsStateSelectListMultipleComponent extends BdMapsStateAbstractSelectList<
  BdState[]
> {
  readonly states = input<BdState[]>();
  readonly initialStateIds = input<number[]>();
  readonly options = input<BdMapsStateSelectOptions>(
    BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT,
  );
  readonly statesSelect = output<BdState[]>();

  public override selectionHandler = new BdMapsStateSelectMultipleHandler();

  constructor() {
    super();

    this.selectionHandler.statesSelect$.subscribe((resource) => {
      this.statesSelect.emit(resource);
    });

    effect(() => {
      const states = this.states();
      if (states) this.selectionHandler.states = states;
    });

    effect(() => {
      const ids = this.initialStateIds();
      if (ids) this.selectionHandler.initialStateIds = ids;
    });

    effect(() => {
      const opts = this.options();
      if (opts) this.selectionHandler.options = opts;
    });
  }

  public onCheckboxChange(event: CheckboxChangeEvent, state: BdState) {
    let currentState: BdState[] = this.selectionHandler.selectedResources || [];
    currentState = currentState.filter((it) => it.id !== state.id);

    if (event.checked) {
      this.selectionHandler.updateSelection(currentState.concat(state));
    } else {
      this.selectionHandler.updateSelection(currentState);
    }
  }

  public isChecked(state: BdState): boolean {
    if (this.selectionHandler.selectedResources) {
      return this.selectionHandler.selectedResources
        .map((it) => it.id)
        .includes(state.id);
    } else {
      return false;
    }
  }
}
